import "./ContainerLeft.scss";

const ContainerLeft = (props) => {
  return <div className="container--left">{props.children}</div>;
};

export default ContainerLeft;
